import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["tabindex"]
const _hoisted_2 = { class: "form__checkbox" }
const _hoisted_3 = ["id", "name", "value"]
const _hoisted_4 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.formClass),
    tabindex: _ctx.tabIndex
  }, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        id: _ctx.id,
        name: _ctx.name,
        value: _ctx.formValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3), [
        [_vModelCheckbox, _ctx.inputValue]
      ]),
      _createElementVNode("label", { for: _ctx.id }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8 /* PROPS */, _hoisted_4)
    ]),
    _withDirectives(_createElementVNode("div", { class: "form__error" }, _toDisplayString(_ctx.errorMessage), 513 /* TEXT, NEED_PATCH */), [
      [_vShow, _ctx.errorMessage]
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}